import { MESSAGE_DEFAULTS } from "./messages.defaults";

let messages: Record<string, string> = { ...MESSAGE_DEFAULTS };

export async function initMessages(): Promise<void> {
    try {
        const res = await fetch("/api/messages", { cache: "no-store", credentials: "include" });
        if (res.ok) {
            const remote = (await res.json()) as Record<string, string>;
            messages = { ...MESSAGE_DEFAULTS, ...remote };
        }
    } catch {
        /* use bundled defaults */
    }
}

export function msg(key: string, vars?: Record<string, string | number>): string {
    let text = messages[key] ?? MESSAGE_DEFAULTS[key];
    if (!text) {
        console.warn(`Missing message: ${key}`);
        return key;
    }
    if (vars) {
        for (const [k, v] of Object.entries(vars)) {
            text = text.replaceAll(`{{${k}}}`, String(v));
        }
    }
    return text;
}

export function msgParagraphs(key: string, vars?: Record<string, string | number>): string[] {
    return msg(key, vars)
        .split(/\n\n+/)
        .map((p) => p.trim())
        .filter(Boolean);
}
